import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  date = new Date().getFullYear();
  mailText: string;

  constructor() {}

  ngOnInit(): void {}

  goToUrl(url: string): void {
    window.location.href = url;
  }

  sendMail(): void {
    this.mailText = 'mailto:remitfree@gmail.com'; // add the links to body
    window.location.href = this.mailText;
  }
}
